// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui';
import moment from 'moment'
import store from '@/utils/global'
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/validateconfig';
import sensors from '@/utils/sensorsdata.es6.min'
import App from './App'
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$moment = moment;

// 重写发送数据
window.userID =''; //null
sensors.batchSend.add = function (data) {
  if (sensors._.isObject(data)) {
    data.properties['$user_id'] = window.userID;
    this.writeStore(data);
    if (data.type === 'track_signup' || data.event === '$pageview') {
      this.sendStrategy();
    }
  }
}

sensors.batchSend.sendStrategy = function () {
  if (document.hasFocus() === false) {
    return false;
  }
  const data = this.readStore();

  if (data.keys.length > 0 && this.sendingData === 0) {
    // 修改发送数据
    data.vals.forEach(val => {
      switch (val.event) {
        case '$pageview':
          val.event = 'WebPageView';
          break;
        case '$WebStay':
          val.event = 'WebStay';
          break;
        case '$WebClick':
          val.event = 'WebClick';
          break;
      }
      let newProperties = {};
      for (let [k, v] of Object.entries(val.properties)) {
        newProperties[k.replace('$', '')] = v;
      }
      newProperties['app_version'] = '';
      newProperties.project_name = '红期-数据接口';
      newProperties.distinct_id = val.distinct_id;
      if (newProperties.hasOwnProperty('url')) {
        newProperties.url = newProperties.url.substring(newProperties.url.indexOf('#') + 1);
      }
      if (val.event === 'WebPageView' && newProperties.hasOwnProperty('referrer')) {
        newProperties.referrer = newProperties.referrer.substring(newProperties.referrer.indexOf('#') + 1);
      }
      delete val.distinct_id;
     // newProperties['user_id'] = window.userID;
      val.properties = newProperties;

    });
    this.sendingData = 1;

    this.sendPrepare(data);
  }
}

sensors.init({
  server_url: process.env.VUE_APP_SENSOR_URL,
  is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time:true,
  batch_send: true,
  send_type:'beacon',
  show_log:false,//true 打印采集事件 false 关闭
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap:'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map:'default',
    collect_element(target) {
      if (target.className.indexOf('el-icon-date')>-1) {
        target.setAttribute('name', target.nextSibling.getAttribute('name'));
      }
      return true;
    },
    collect_tags: {
      li: true,
      span:true,
      svg:true,
      i:true
    },
    get_vtrack_config: false
  }
});
const whiteList = ['index', 'webIndex'];

router.beforeEach((to, from, next) => {
  store.dispatch('getuserinfo').then(res => {
    console.log('beforeEach');
    if (whiteList.includes(to.name) || store.state.user.islogin !== 0) {
      next();
    } else {
      next({ name: 'webIndex' })
    }
  })
})

function loadScript(src){
  return new Promise((resolve,reject)=>{
    if(!src) return resolve();
    const existed = document.querySelector(`script[src="${src}"]`);
    if(existed) return resolve();

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(script);
  })
}

loadScript(process.env.VUE_APP_LOGIN_SDK_URL).then(()=>{
  // console.log('login sdk loaded');
}).catch((err)=>{
  console.error('Failed to load login sdk:', err);
});

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
/* eslint-disable no-new */

